module.exports = __webpack_public_path__ + "static/media/DPD_logo.5a176450.svg";